import { Button, Typography } from "@mui/joy";
import { Box } from "@mui/system";
import { ReactElement } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { setFormOpen } from "../reducers/rhapsody";
import Forms from "src/hooks/forms/forms";
import { Outlet, useParams } from "react-router-dom";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function FormsPage(): ReactElement {
  const params = useParams();
  const id = params.id || "";
  const dispatch = useDispatch();
  if (id) return <Outlet />;

  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        gap: 2,
        flexDirection: "column",
        maxWidth: 1600,
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
      }}
    >
      <Helmet>
        <title>Rhapsody | Forms</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: 800, fontSize: 24 }} level="h4">
          Forms
        </Typography>
        <Button
          onClick={() =>
            dispatch(setFormOpen({ isOpen: true, formID: "form" }))
          }
          size="sm"
        >
          + Add Form
        </Button>
      </Box>
      <Forms />
    </Box>
  );
}
